import { ReactElement } from 'react';
import { connect } from 'react-redux';
import PortfolioPage from 'pages/portfolio/portfolio-page';
import { IStoreState } from 'store';
import { EForecastEvaluationType } from 'store/deal-evaluation/types';
import { setForecastType } from 'store/deal-evaluation/actions';
import { evaluateDeals } from 'store/deal-comparison/actions';
import { setParetoIsModalOpen } from 'store/pareto/actions';
import { EModalTitle } from 'lib/storage';
import { IDeal } from 'store/deals/types';
import { getFilteredDeals } from 'pages/pareto/add-deal-modal/selectors';
import { clearModalContent, setModalContent } from 'store/modal/actions';
import { setPortfolioDealIds } from 'store/portfolio/actions';

interface IPortfolioPageStateProps {
  selectedForecastType: EForecastEvaluationType;
  portfolioDealIds: string[];
  filteredDeals: IDeal[];
}

interface IPortfolioPageDispatchProps {
  evaluateDeals: () => void;
  setForecastType: (forecastType: EForecastEvaluationType) => void;
  setParetoIsModalOpen: (isModalOpen: boolean, title: EModalTitle) => void;
  clearModalContent: () => void;
  setModalContent: (content: ReactElement) => void;
  setPortfolioDealIds: (portfolioDealIds: string[]) => void;
}

export type TPortfolioPageProps = IPortfolioPageStateProps & IPortfolioPageDispatchProps;

const mapStateToProps = (state: IStoreState): IPortfolioPageStateProps => ({
  selectedForecastType: state.dealEvaluation.selectedForecastType,
  portfolioDealIds: state.pareto.portfolioDealIds,
  filteredDeals: getFilteredDeals(state),
});

const mapDispatchToProps = {
  evaluateDeals,
  setForecastType,
  setParetoIsModalOpen,
  clearModalContent,
  setModalContent,
  setPortfolioDealIds,
};

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioPage);
